import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../../app.store';

const locationListHoveredMarkerIdSelector = (state: AppState) => state.frontendState.mapTools.locationFinder.hoveredMarkerId;
export const useLocationListHoveredMarkerIdSelector = () => useSelector(locationListHoveredMarkerIdSelector);
